import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';

// shared
import { IconCart } from '../../shared/icons';

// services
import { isAuthenticated } from '../../services/user';

// actions
import { modalLogin } from '../../actions/modals';

// styles
import { cart as CartStyle } from './style';

class Cart extends Component {
  handleCartClick = (e) => {
    if (!isAuthenticated()) {
      e.preventDefault();
      // Abre o modal de login/cadastro com identificação de origem 'cart'
      this.props.modalLogin('cart');
    }
    // Se estiver autenticado, o Link funciona normalmente
  };

  render() {
    return (
      <CartStyle>
        <Link to="/carrinho" title={'Carrinho'} onClick={this.handleCartClick}>
          <IconCart />
          {this.props.numberItens ? <span>{this.props.numberItens}</span> : ''}
        </Link>
      </CartStyle>
    );
  }
}

const mapStateToProps = state => {
  return {
    numberItens: state.cart.numberItens,
  };
};

export default connect(mapStateToProps, { modalLogin })(withRouter(Cart));